module.exports = __webpack_public_path__ + "img/icon-notification.0ae8155a.png";